import { render, staticRenderFns } from "./table-high-level-column.vue?vue&type=template&id=711bb635&scoped=true&"
import script from "./table-high-level-column.vue?vue&type=script&lang=js&"
export * from "./table-high-level-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711bb635",
  null
  
)

export default component.exports